{
  "internal_id": {
    "source": "regulator",
    "domainType": "number",
    "ui": {
      "isNotRenderable": true
    }
  },
  "expiry_date": {
    "source": "regulator",
    "domainType": "DateString",
    "ui": {
      "label": "Expiry Date",
      "width": 125,
      "isShownByDefault": true
    }
  },
  "province": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Province",
      "width": 80,
      "isShownByDefault": true
    }
  },
  "zones": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Zone",
      "width": 200,
      "isShownByDefault": true
    }
  },
  "owners_json_array": {
    "source": "regulator",
    "domainType": "object",
    "ui": {
      "label": "Historical Owner",
      "width": 200,
      "isShownByDefault": true
    }
  },
  "status": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Status",
      "width": 140,
      "isShownByDefault": true
    }
  },
  "area_ha": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "ha"
    },
    "ui": {
      "label": "Area",
      "width": 80,
      "isShownByDefault": true
    }
  },
  "petroninja_land_ids": {
    "source": "regulator",
    "domainType": "object",
    "ui": {
      "isNotRenderable": true
    }
  }
}
